<template>
    <div v-if="language.includes('es')">

        <a href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Color.png" class="logo"></a>
        <h1> Colaboradores </h1>  

        <a href="https://www.palmbeachschools.org/SouthGradeElementary" target="_blank">
            <div class="partner-container">
                <div class="partner-logo">
                    <img src="https://www.palmbeachschools.org/cms/lib/FL50010848/Centricity/Template/GlobalAssets/images///logos/SouthGradeES_logoHP.jpg">
                </div>
                <div class="partner-name">
                    <h3> South Grade Elementary School </h3>
                    <p> Educar. Afirmar. Inspirar. </p>
                </div>
            </div>
        </a>

        <a href="https://funifelt.wixsite.com/gimnasiobilingue" target="_blank">
            <div class="partner-container">
                <div class="partner-logo">
                    <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Flogo_gimnasio_bilingue.png?alt=media&token=3f87bda7-2634-4c9e-a0cd-483f66457607">
                </div>
                <div class="partner-name">
                    <h3> Gimnasio Bilingüe </h3>
                    <p> Fomenta la motivación, el reconocimiento, la experimentación, la exploración y el descubrimiento de los niños que se desarrollan en el proceso de aprendizaje bilingüe. </p>
                </div>
            </div>
        </a>

    </div>

    <div v-else>
        <a href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Color.png" class="logo"></a>
        <h1> Partners </h1>  
        <a href="https://www.palmbeachschools.org/SouthGradeElementary" target="_blank">
            <div class="partner-container">
                <div class="partner-logo">
                    <img src="https://www.palmbeachschools.org/cms/lib/FL50010848/Centricity/Template/GlobalAssets/images///logos/SouthGradeES_logoHP.jpg">
                </div>
                <div class="partner-name">
                    <h3> South Grade Elementary School </h3>
                    <p> Educate. Affirm. Inspire. </p>
                </div>
            </div>
        </a>

        <a href="https://funifelt.wixsite.com/gimnasiobilingue" target="_blank">
            <div class="partner-container">
                <div class="partner-logo">
                    <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Flogo_gimnasio_bilingue.png?alt=media&token=3f87bda7-2634-4c9e-a0cd-483f66457607">
                </div>
                <div class="partner-name">
                    <h3> Gimnasio Bilingüe </h3>
                    <p> English version. </p>
                </div>
            </div>
        </a>

    </div>

</template>

<script>

export default {
    name : 'partners',
    data () {
        return {
            language: navigator.language
        }
    },
    mounted () {
        if (this.language.includes('es')) {
            document.title = 'Colaboradores'
        } else {
            document.title = 'Partners'
        }
    }
}

</script>

<style src="@/assets/css/footer/partners.css" scoped></style>
